export default "__VITE_ASSET__1bff2b14__"